export const isTestCafeEnabled = () => process.env.VUE_APP_TESTCAFE_PAYMENT_ENDPOINT &&
    sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG'

export default { isTestCafeEnabled }
